import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'
import carteStoreLocator from './carteStoreLocator.png'

export const StoreLocator = () => {
   const data = {
      title: 'Orange est là, partout en France',
      description: 'Découvrez les boutiques proches de chez vous',
      image: carteStoreLocator,
      CTA: {
         label: 'Trouver une boutique',
         URL: 'https://agence.orange.fr/',
         analytics: {
            oeventCategory: 'offre',
            oeventAction: 'trouver-une-boutique',
            oeventLabel: 'https://agence.orange.fr/',
            oeventOther: '{"track_refZ":"acc-digital_hpnl_store-locator"}',
            pdbZid: 'acc-digital_hpnl_store-locator',
            pdbSc: 'mtp',
            pdbIdc: 'xxxxx',
            pdbVi: '',
         },
      },
   }
   return (
      <div class="container-fluid mt-2 mb-2">
         <div class="store-locator row">
            <div class="text col-12 col-md-5 offset-md-1">
               <div>
                  <h2 class="no-signature mb-0" dangerouslySetInnerHTML={{ __html: tagParser(data.title) }}></h2>
                  <p class="mb-2">{data.description}</p>
                  <a
                     href={data.CTA.URL}
                     class="btn btn-primary mb-2 mb-md-0"
                     data-pdb-vi=""
                     data-pdb-zid={data.CTA.analytics.pdbZid}
                     data-pdb-sc={data.CTA.analytics.pdbSc}
                     data-pdb-idc={data.CTA.analytics.pdbIdc}
                     data-oevent-category={data.CTA.analytics.oeventCategory}
                     data-oevent-action={data.CTA.analytics.oeventAction}
                     data-oevent-label={data.CTA.analytics.oeventLabel}
                     data-oevent-other={data.CTA.analytics.oeventOther}
                  >
                     {data.CTA.label}
                  </a>
               </div>
            </div>
            <div class="visuel col-12 col-md-6">
               <img src={data.image} alt="" loading="lazy" width="300" />
            </div>
         </div>
      </div>
   )
}
